import React, { useEffect, useState } from 'react'
import { Tabs } from 'antd'
import { t } from 'i18next'
import { get } from '../../Common/api'
import GepetoSummary from './GepetoSummary'
import { DEFAULT_PERIOD, PingChart, SessionChart, SpeedtestChart, SystemChart } from './GepetoCharts'

// ces onglets partagent la même série de logs système, chargée une seule fois par période
const SYSTEM_TABS = ['ping', 'session', 'system']

export default function GepetoTabs ({ gepeto, setGepeto }) {
  const [activeTab, setActiveTab] = useState('summary')
  const [period, setPeriod] = useState(DEFAULT_PERIOD)
  const [speedtests, setSpeedtests] = useState(null)
  const [systemLogs, setSystemLogs] = useState(null)
  const [loading, setLoading] = useState(false)

  const loadSeries = async (source, setSeries) => {
    setLoading(true)
    await get({
      url: `admin/gepetos/${gepeto.id}/${source}`,
      params: { days: period },
      onSuccess: (json) => {
        setSeries(json.series)
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    if (activeTab === 'speedtest' && !speedtests) {
      loadSeries('speedtests', setSpeedtests)
    }
    if (SYSTEM_TABS.includes(activeTab) && !systemLogs) {
      loadSeries('system_logs', setSystemLogs)
    }
  }, [activeTab, period])

  const updatePeriod = (days) => {
    setPeriod(days)
    setSpeedtests(null)
    setSystemLogs(null)
  }

  const chartProps = { period, setPeriod: updatePeriod, loading }

  const tab = (key, children) => ({ key, label: t(`Admin.GepetoPage.tab.${key}`), children })

  return (
    <Tabs
      activeKey={activeTab}
      onChange={setActiveTab}
      items={[
        tab('summary', <GepetoSummary gepeto={gepeto} setGepeto={setGepeto} />),
        tab('speedtest', <SpeedtestChart points={speedtests} {...chartProps} />),
        tab('ping', <PingChart points={systemLogs} {...chartProps} />),
        tab('session', <SessionChart points={systemLogs} {...chartProps} />),
        tab('system', <SystemChart points={systemLogs} {...chartProps} />)
      ]}
    />
  )
}
